import { render, staticRenderFns } from "./Estatisticacas.vue?vue&type=template&id=d0a2d1b6&scoped=true&"
import script from "./estatisticacas.ts?vue&type=script&lang=ts&"
export * from "./estatisticacas.ts?vue&type=script&lang=ts&"
import style0 from "./Estatisticacas.vue?vue&type=style&index=0&id=d0a2d1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a2d1b6",
  null
  
)

export default component.exports